import { hotAnime } from '@/mocks/anime';
import AnimeCard from '@/components/base/AnimeCard';
import SectionHeader from '@/components/base/SectionHeader';

interface HotSectionProps {
  query: string;
}

export default function HotSection({ query }: HotSectionProps) {
  const keyword = query.trim().toLowerCase();
  const filtered = keyword
    ? hotAnime.filter(
        (a) =>
          a.title.toLowerCase().includes(keyword) ||
          a.tags.some((t) => t.toLowerCase().includes(keyword)),
      )
    : hotAnime;

  return (
    <section id="recommend" className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeader
          eyebrow="热门治愈番推荐"
          title="人人都爱的温馨治愈佳作"
          description={
            keyword
              ? `为你找到 ${filtered.length} 部与“${query}”相关的推荐`
              : '精选口碑最好的治愈系与温馨动画，闭眼入都不会踩雷。'
          }
          linkText="查看更多治愈番"
          linkHref="/category/healing"
        />
        {filtered.length > 0 ? (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {filtered.map((anime) => (
              <AnimeCard key={anime.id} anime={anime} />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center gap-3 rounded-2xl bg-background-50 py-16 text-center">
            <i className="ri-search-eye-line text-4xl text-secondary-400"></i>
            <p className="text-sm text-foreground-600">
              没找到与“{query}”相关的动画，换个关键词试试吧～
            </p>
          </div>
        )}
      </div>
    </section>
  );
}